import { onMounted, onUnmounted, ref } from 'vue'

export const useGlobalContextMenuShowControl = () => {
  const isShift = ref(false)
  const isCtrl = ref(false)

  const down = (e: KeyboardEvent) => {
    if (e.key === 'Shift') isShift.value = true
    if (e.key === 'Control') isCtrl.value = true
  }

  const up = (e: KeyboardEvent) => {
    if (e.key === 'Shift') isShift.value = false
    if (e.key === 'Control') isCtrl.value = false
  }

  onMounted(() => {
    window.addEventListener('keydown', down)
    window.addEventListener('keyup', up)
  })

  onUnmounted(() => {
    window.removeEventListener('keydown', down)
    window.removeEventListener('keyup', up)
  })

  return { isShift, isCtrl }
}
